import { z } from "zod";
import { AuditRecordDtoV1 } from "../ports.ts";
import { Cursor, OperatorFilter, PeriodBound } from "./common.ts";

// `GET /audit` (spec explorer-access "[FR] Explorer audit log", design D12; `audit.read`): the
// Explorer and iam audit logs merged by `(occurred_at, id)`, newest first, cursor-paginated. There
// is no edit or delete route.

export const DEFAULT_AUDIT_LIMIT = 50;
export const MAX_AUDIT_LIMIT = 100;

export const AuditQueryV1 = z
  .object({
    operator_id: OperatorFilter.optional(),
    console_user_id: z.uuid().optional(),
    action: z
      .string()
      .regex(/^[a-z][a-z0-9_]{0,63}$/)
      .optional(),
    from: PeriodBound.optional(),
    to: PeriodBound.optional(),
    cursor: Cursor.optional(),
    limit: z.coerce.number().int().min(1).max(MAX_AUDIT_LIMIT).default(DEFAULT_AUDIT_LIMIT),
    /**
     * `access` (adopt-installation-per-customer task 6.11, spec explorer-access "[FR] Access audit
     * log"): the console access records only (iam) with operator-auth's credentials and operator
     * configuration; `all` (or absent): the Explorer's, the List Entries' and iam's records.
     */
    view: z.enum(["all", "access"]).optional(),
  })
  .strict()
  .meta({ id: "AuditQueryV1" });
export type AuditQueryV1 = z.infer<typeof AuditQueryV1>;

export const AuditResponseV1 = z
  .object({
    items: z.array(AuditRecordDtoV1),
    next_cursor: Cursor.nullable(),
  })
  .strict()
  .meta({ id: "AuditResponseV1" });
export type AuditResponseV1 = z.infer<typeof AuditResponseV1>;
